// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import  { userActions }       from '../../../redux/actions/user';
import Dashboard                   from './Dashboard';


const mapStateToProps = (state) => {
  return {
    userResponse:  state.user.userResponse
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...userActions
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);




// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/index.js